import { render } from "./SubscriptionOrders.vue?vue&type=template&id=75ebbd07&scoped=true&ts=true"
import script from "./SubscriptionOrders.vue?vue&type=script&lang=ts"
export * from "./SubscriptionOrders.vue?vue&type=script&lang=ts"

import "./SubscriptionOrders.vue?vue&type=style&index=0&id=75ebbd07&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ebbd07"]])

export default __exports__